import React, { useState, useEffect } from 'react';
import { IonContent, IonPage } from "@ionic/react";
import { withRouter } from "react-router";
import Header from "src/components/Header";
import Drawer from '@material-ui/core/Drawer';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { fetchCierreDiarioOperarios, IOperario, IOperariosResponse } from '../services/CierreDiarioOperarios';
import { fetchAsignacionDetalle, IAsignacionDetalle } from 'src/services/CierreDiarioHorarios';
import "./CierreDiarioOperarios.css";
import api from 'src/services/api';

const CierreDiarioOperarios = (props) => {
  const { ps_id, fecha } = props.match.params;

  const [operariosData, setOperariosData] = useState<IOperariosResponse | null>(null);
  const [asignacionDetalle, setAsignacionDetalle] = useState<IAsignacionDetalle | null>(null);
  const [selectedOperario, setSelectedOperario] = useState<IOperario | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [operacion, setOperacion] = useState<'AA' | 'RA' | 'RE' | null>(null);
  const [motivo, setMotivo] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<'success' | 'error' | 'warning' | 'info'>('success');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
const history = props.history;

  const getOperariosData = async () => {
    try {
      const data = await fetchCierreDiarioOperarios(Number(ps_id), fecha);
      setOperariosData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error as Error);
    } finally {
      setLoading(false);
    }
  };

  const handleOperarioClick = async (operario: IOperario) => {
    console.log(operario);
    setSelectedOperario(operario);
    setDrawerOpen(true);
    try {
      const horarios = await fetchAsignacionDetalle(operario.ps_id, operario.asig_id);
      setAsignacionDetalle(horarios[0]);
      console.log(horarios[0]);
    } catch (error) {
      console.error("Error fetching horarios:", error);
      setAsignacionDetalle(null);
    }
  };

  const handleCierreDiario = async () => {
    if (!selectedOperario || !asignacionDetalle) {
      console.error("Datos del operario o asignación no disponibles.");
      return;
    }

    const body = {
      asig_id: asignacionDetalle.asig_cab_id,
      fecha: asignacionDetalle.fecha_inicio,
      op_id: selectedOperario.op_id,
      ps_codigo: selectedOperario.ps_id.toString(),
      operacion: operacion,
      motivo: (operacion === 'RE') ? motivo : null
    };

    try {
      const response = await api.post(`/cierre_diario/guardar`, {
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      });

      const data = await response.data;

      if (response.status === 200) {
        openToast(data.info, 'success');
      } else {
        openToast(data.error, 'error');
      }
    } catch (error) {
      console.error("Error al guardar la gestión de cierre diario:", error);
    }
  };

  const openToast = (message, severity) => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  useEffect(() => {
    getOperariosData();
  }, [ps_id, fecha]);

  const formatDate = (inputDate: string) => {
    if (!inputDate) return '';
    const [year, month, day] = inputDate.split('-');
    return `${day}/${month}/${year}`;
  };


  return (
    <IonPage>
      <Header titulo="Cierre Diario" />
      <IonContent id="CierreDiario_Operarios">
        <div className="container mb-3 cierreDiario_operarios">
          <div className="contrato_title">
            <h1>
              {loading ? 'Cargando...' : error ? 'Sin datos' : operariosData ? operariosData.nombre : 'Sin datos'}
            </h1>
            <p>
              {loading ? '...' : error ? '...' : operariosData ? ` Lista de personas que marcaron No Corresponde Asignación en fecha ${formatDate(operariosData.fecha)} ` : ' Sin fecha'}
            </p>
          </div>

          <div className="operarios">
            {operariosData && operariosData.operarios.length > 0 ? (
              operariosData.operarios.map(operario => (
                <div className="operario" key={operario.asig_id} onClick={() => handleOperarioClick(operario)}>
                  <div className="operario_ContentText">
                    <div className="operario_label">Nombre:</div>
                    <div className="operario_text">{operario.operario}</div>
                  </div>
                  <div className="operario_row">
                    <div className="operario_col">
                      <div className="operario_ContentText">
                        <div className="operario_label">Legajo:</div>
                        <div className="operario_text">{operario.legajo}</div>
                      </div>
                      <div className="operario_ContentText">
                        <div className="operario_label">Cedula:</div>
                        <div className="operario_text">{operario.cedula}</div>
                      </div>
                    </div>
                    <div className="operario_col">
                      <div className="operario_ContentText">
                        <div className="operario_label">fecha de inicio:</div>
                        <div className="operario_text">{formatDate(operario.fechainicio)}</div>
                      </div>
                      <div className="operario_ContentText">
                        <div className="operario_label">Celular:</div>
                        <div className="operario_text">{operario.telefono}</div>
                      </div>
                    </div>
                  </div>
                </div>

              ))) : (
              <p>No hay operarios para mostrar.</p>
            )}
          </div>
        </div>


        <Drawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <div className="drawer-content">
            <div className="detalleHorarios">
              <div
                className="close"
                onClick={() => setDrawerOpen(false)}>
                <span>Cerrar horarios</span>
                <svg width={12} height={13} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                  <path d="M6.0619 7.95915L10.0861 3.94035C10.1252 3.90108 10.1717 3.87005 10.223 3.84909C10.2743 3.82814 10.3292 3.81769 10.3846 3.81836C10.44 3.81903 10.4947 3.83081 10.5455 3.853C10.5962 3.87519 10.642 3.90735 10.6801 3.94755C10.7582 4.02979 10.8011 4.13923 10.7997 4.25261C10.7984 4.366 10.7529 4.47439 10.6729 4.55475L6.3511 8.87055C6.31232 8.90959 6.26615 8.94051 6.21528 8.9615C6.16441 8.98249 6.10987 8.99313 6.05484 8.9928C5.99982 8.99246 5.94541 8.98116 5.8948 8.95955C5.84419 8.93794 5.7984 8.90646 5.7601 8.86695L1.3231 4.32435C1.24457 4.24303 1.20068 4.1344 1.20068 4.02135C1.20068 3.90831 1.24457 3.79967 1.3231 3.71835C1.36169 3.67862 1.40785 3.64703 1.45887 3.62546C1.50988 3.60389 1.56471 3.59277 1.6201 3.59277C1.67549 3.59277 1.73031 3.60389 1.78133 3.62546C1.83234 3.64703 1.87851 3.67862 1.9171 3.71835L6.0619 7.95915Z" fill="#404040" /></svg>
              </div>
              {/* Detalles del Operario */}
              <div className="operario_ContentText">
                <div className="operario_label">Nombre:</div>
                <div className="operario_text">
                  {selectedOperario && (
                    <div className="nombre_operario">
                      {selectedOperario.operario}
                    </div>
                  )}
                </div>
              </div>

              {asignacionDetalle ? (
                <>
                  <div className="operario_ContentText" key={asignacionDetalle.id}>
                    <div className="operario_label">Total de horas:</div>
                    <div className="operario_text">{asignacionDetalle.total_horas}</div>
                  </div>

                  <div className='horarios'>
                    <div className="horario_head">
                      <span>Entrada</span>
                      <span>Salida</span>
                    </div>

                    {Object.entries({
                      Lunes: ['lun_ent', 'lun_sal'],
                      Martes: ['mar_ent', 'mar_sal'],
                      Miércoles: ['mie_ent', 'mie_sal'],
                      Jueves: ['jue_ent', 'jue_sal'],
                      Viernes: ['vie_ent', 'vie_sal'],
                      Sábado: ['sab_ent', 'sab_sal'],
                      Domingo: ['dom_ent', 'dom_sal']
                    }).map(([dia, [entrada, salida]]) => {
                      return asignacionDetalle[entrada] && (
                        <div className="horario" key={dia}>
                          <span className="horario_dia">{dia}</span>
                          <span className="horario_hora">{asignacionDetalle[entrada]}</span>
                          <span className="horario_hora">{asignacionDetalle[salida]}</span>
                        </div>
                      )
                    })}

                  </div>
                  <div className="botones">

                    <button onClick={() => {
                      setOperacion('RA');
                      history.push('/gestiones');
                    }}>Reemplazo</button>

                    <button onClick={() => {
                      setOperacion('AA');
                      history.push('/gestiones');
                    }}>asignación</button>

                    <button onClick={() => {
                      setOperacion('RE');
                      setDrawerOpen(false)
                      setShowModal(true);
                    }}>Rechazado</button>

                  </div>
                </>
              ) : (
                <div className="no-data-message">
                  <p>No hay datos disponibles para este operario.</p>
                </div>
              )}
            </div>
          </div>
        </Drawer>

        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <h4>Detalle de Rechazo</h4>
              <p>Nombre: {selectedOperario?.operario}</p>
              <p>Fecha: {formatDate(selectedOperario?.fechainicio || '')}</p>
              <textarea
                placeholder="Escriba el motivo del rechazo aquí..."
                onChange={(e) => setMotivo(e.target.value)}
              />
              <div className="modal-buttons">
                <button className='modal-back' onClick={() => setShowModal(false)}>Volver</button>
                <button onClick={() => {
                  handleCierreDiario();
                  setShowModal(false);
                }}>Rechazo</button>
              </div>
            </div>
          </div>
        )}

        <Snackbar
          open={toastOpen}
          autoHideDuration={6000}
          onClose={() => setToastOpen(false)}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={toastSeverity}
            onClose={() => setToastOpen(false)}
          >
            {toastMessage}
          </MuiAlert>
        </Snackbar>

      </IonContent>
    </IonPage>
  );
};

export default withRouter(CierreDiarioOperarios);
